import dayjs from 'dayjs';
import type { CompanyBalanceOrder } from './companyBalanceApi';
import { resolveOrderRealization } from './companyBalanceRealization';

export type CompanyBalanceOrderSortKey =
  | 'DATE'
  | 'REALIZATION'
  | 'REVENUE'
  | 'COST'
  | 'MARGIN';

export interface CompanyBalanceOrderSort {
  key: CompanyBalanceOrderSortKey;
  direction: 'ascend' | 'descend';
}

function dateValue(order: CompanyBalanceOrder): number {
  const parsed = order.plannedDate ? dayjs(order.plannedDate) : null;
  return parsed?.isValid() ? parsed.valueOf() : 0;
}

function sortValue(order: CompanyBalanceOrder, key: CompanyBalanceOrderSortKey): number | null {
  if (key === 'REALIZATION') return resolveOrderRealization(order.evidence).percent;
  if (key === 'REVENUE') return order.current.revenue;
  if (key === 'COST') return order.current.totalCost;
  if (key === 'MARGIN') return order.current.margin;
  return dateValue(order);
}

export function sortCompanyBalanceOrders(
  orders: CompanyBalanceOrder[],
  sort: CompanyBalanceOrderSort,
): CompanyBalanceOrder[] {
  const direction = sort.direction === 'ascend' ? 1 : -1;
  return [...orders].sort((left, right) => {
    const leftValue = sortValue(left, sort.key);
    const rightValue = sortValue(right, sort.key);
    if (leftValue == null) return rightValue == null ? 0 : 1;
    if (rightValue == null) return -1;
    const difference = leftValue - rightValue;
    if (difference !== 0) return difference * direction;
    return left.displayOrderNumber.localeCompare(right.displayOrderNumber, 'pl');
  });
}
